<template>
  <div class="page">
    <div class="head">
        案例管理
    </div>
    <div class="content">
        <div class="bar">
            <el-input style="width:10%" clearable v-model="query.keyword" placeholder="请输入案例名称">
            </el-input>
           
            <el-button  class="bartip"  @click="toSearch" size="small" type="primary" round>搜索</el-button>
            <span class="el-icon-circle-plus" style="margin-left:20px" @click="toAddHandler">&nbsp;新建案例</span>
        </div>
        <div class="table" >
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                type="index"
                label="序号"
                width="60"
                :index="indexMethod"
                align="center"
                />
                <el-table-column
                    prop="name"
                    align="center"
                    label="案例名称">
                </el-table-column>
                <el-table-column
                    prop="type"
                    label="类型">
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="content"
                    label="内容">
                </el-table-column>
                <el-table-column
                    prop="statusName"
                    align="center"
                    label="状态"
                    >
                </el-table-column>
                <el-table-column
                    prop="createdAt"
                    align="center"
                    label="创建时间">
                </el-table-column>
                <el-table-column label="操作">
                    <template #default="record">
                        <el-link :underline="false" @click.prevent="editHandler(record.row)" type="primary">编辑</el-link>
                        <el-link :underline="false" @click.prevent="drawer = true,findList(record.row.id)" type="primary">内容管理  </el-link>
                        <el-link :underline="false" @click.prevent="deleteHandler(record.row)" type="primary">删除</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
            <el-pagination
            @current-change="handleCurrentChange"
            :current-page="query.currentPage"
            :page-size="query.size"
            layout="total, prev, pager, next, jumper"
            :total="query.total"
            />
        <!-- 表单 添加课程 -->
        <el-dialog :title="title" :visible.sync="visible" @close="dialogCloseHandler">
            <el-form ref="userForm" :model="form" :rules="rules">
                <el-form-item label="案例名" label-width="100px" prop="name">
                <el-input v-model="form.name" autocomplete="off" />
                </el-form-item>
                <el-form-item label="类型" label-width="100px" prop="type">
                <el-input v-model="form.type" autocomplete="off" />
                </el-form-item>
                <el-form-item label="内容" label-width="100px" prop="content">
                <el-input v-model="form.content" autocomplete="off" />
                </el-form-item>
                <el-form-item label="状态" label-width="100px" prop="status">
                <el-input v-model="form.status" autocomplete="off" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeModal">取 消</el-button>
                <el-button type="primary" size="small" @click="submitHandler">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 表单 编辑课程 -->
        <el-dialog :title="title2" :visible.sync="visible2" @close="dialogCloseHandler2">
            <el-form ref="userForm2" :model="form2" >
                <el-form-item label="案例名称" label-width="100px" prop="name">
                <el-input v-model="form2.name" autocomplete="off" />
                </el-form-item>
                <el-form-item label="类型" label-width="100px" prop="type">
                <el-input v-model="form2.type" autocomplete="off" />
                </el-form-item>
                <el-form-item label="内容" label-width="100px" prop="type">
                <el-input  type="textarea"
                        :autosize="{ minRows: 5, maxRows: 500}"
                        maxlength="1000"
                        show-word-limit 
                        v-model="form2.content" autocomplete="off" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeModal2">取 消</el-button>
                <el-button type="primary" size="small" @click="submitHandler2">确 定</el-button>
            </div>
        </el-dialog>
        <!--查看课程 -->
        <el-drawer
            title="内容管理"
            direction="ltr"
            :visible.sync="drawer"
            size="100%">
            <el-table   
                :data="lessonData"
                stripe
                style="width: 100%">

                <el-table-column
                type="index"
                width="50">
                </el-table-column>
                <el-table-column
                prop="name"
                label="名称"
                width="100">
                </el-table-column>
                 <el-table-column
                prop="route"
                label="路由"
                width="170">
                </el-table-column>

                <el-table-column
                prop="content"
                label="文字内容"
                show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                prop="tips"
                label="知识库内容"
                show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                prop="handlingInstruction"
                label="操作说明内容"
                show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column label="操作">
                    <template #default="record">
                        <el-link :underline="false" @click.prevent="editListenData(record.row)" type="primary">编辑</el-link>
                        <el-link :underline="false" @click.prevent="lookListenData(record.row)" type="primary">查看</el-link>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <el-dialog title="编辑" :visible.sync="lessonvisible" :modal="false">
                    <el-form ref="lessonData2" :model="lessonData2" >
                        <el-form-item label="名称" label-width="100px" prop="name">
                        <el-input v-model="lessonData2.name" autocomplete="off" />
                        </el-form-item>
                        <el-form-item label="文字内容" label-width="100px" prop="content">
                        <el-input 
                        type="textarea"
                        :autosize="{ minRows: 5, maxRows: 500}"
                        maxlength="1000"
                        show-word-limit
                         v-model="lessonData2.content" autocomplete="off" />
                        </el-form-item>
                        <el-form-item label="知识库内容" label-width="100px" prop="tips">
                        <el-input
                        type="textarea"
                        :autosize="{ minRows: 5, maxRows: 500}"
                        maxlength="1000"
                        show-word-limit
                         v-model="lessonData2.tips" autocomplete="off" />
                        </el-form-item>

                         <el-form-item label="操作说明内容" label-width="100px" prop="tips">
                        <el-input
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 500}"
                        maxlength="1000"
                        show-word-limit
                         v-model="lessonData2.handlingInstruction" autocomplete="off" />
                        </el-form-item>

                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button size="small" @click="closeModal">取 消</el-button>
                        <el-button type="primary" size="small" @click="editlookListenData">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
            <div>
                <el-dialog title="查看" :visible.sync="lessonvisible2" :modal="false">
                    <el-form ref="lessonData2" :model="lessonData2" >
                        <el-form-item label="名称" label-width="100px" prop="name">
                        <el-input :disabled="true" v-model="lessonData2.name" autocomplete="off" />
                        </el-form-item>
                        <el-form-item label="内容" label-width="100px" prop="content">
                        <el-input 
                        :disabled="true"
                        type="textarea"
                        :autosize="{ minRows: 5, maxRows: 500}"
                        maxlength="1000"
                        show-word-limit
                         v-model="lessonData2.content" autocomplete="off" />
                        </el-form-item>
                        <el-form-item label="提示" label-width="100px" prop="tips">
                        <el-input
                        :disabled="true"
                        type="textarea"
                        :autosize="{ minRows: 5, maxRows: 500}"
                        maxlength="1000"
                        show-word-limit
                         v-model="lessonData2.tips" autocomplete="off" />
                        </el-form-item>

                           <el-form-item label="提示" label-width="100px" prop="tips">
                        <el-input
                        :disabled="true"
                        type="textarea"
                        :autosize="{ minRows: 5, maxRows: 500}"
                        maxlength="1000"
                        show-word-limit
                         v-model="lessonData2.handlingInstruction" autocomplete="off" />
                        </el-form-item>

                    </el-form>
                    
                </el-dialog>
            </div>
        </el-drawer>
    </div>
  </div>
</template>

<script>
import ajaxObj from "@/ajax";
export default {
    inject: ['reload'],
 data(){
     return {
        searchInput:'',
        tableData:[],
        query: {
            currentPage: 1,
            size: 10,
            page:0,
            total: 0,
            keyword:'',
            name:''
        },
        lessonQuery: {
            currentPage: 1,
            size: 10,
            page:0,
            total: 0,
            keyword:'',
            courseId:''
        },
        // 添加 表单
        visible:false,
        visible2:false,
        title:'添加案例信息',
        title2:'修改案例信息',
        form: {},
        form2:{},
        rules: {
            
        },
        // 查看 课程
        drawer: false,
        innerDrawer: false,
        lessonData:[],
        lessonData2:{},
        lessonvisible: false,
        lessonvisible2: false,
    }
 },
 methods:{
     findUserlist(){
        ajaxObj({url: "courses",method: "get",params:this.query})
        .then(response => {
            this.tableData = response.data.data;
            console.log(this.tableData);
        this.query.total = response.data.meta.total;
        })
     },
     // 序号
    indexMethod(index){
       index = index + 1 + (this.query.currentPage - 1) * this.query.size;
      return index;

    },
    //  搜索
     toSearch(){
        this.query.currentPage = 1;
        this.query.page = this.query.currentPage -1;
        ajaxObj({url: "courses",method: "get",params:this.query})
        .then(response => {
            this.tableData = response.data.data;
            this.query.total = response.data.meta.total;
        })
     },
   
    // 添加课程  表单
    dialogCloseHandler() {
        this.$refs.userForm.clearValidate()
    },
    
    toAddHandler() {
      this.form = {}
      this.setTitle('添加案例信息')
      this.showModal()
    },
    setTitle(title) {
      this.title = title
    },
    closeModal() {
      this.visible = false;
      this.lessonvisible =false
    },
    showModal() {
      this.visible = true
    },
    // 添加课程
    submitHandler(){
            // 表单验证
        this.$refs.userForm.validate((valid) => {
            if (valid) {
            // 2 提交表单
                ajaxObj({url: "courses/add",method: "post",
                    data:this.form
                })
                .then((response) => {
                    this.$message({ type: 'success', message: '添加成功' });
                    this.reload()                                               
                })
            } else {
                this.$message({ type: 'error', message: '添加失败' })
            }
        })
    },
    // 修改课程  表单
    dialogCloseHandler2() {
        this.$refs.userForm2.clearValidate()
    },
    setTitle2(title2) {
        this.title2 = title2
    },
    closeModal2() {
      this.visible2 = false
    },
    showModal2() {
      this.visible2 = true
    },
    submitHandler2(){
            // 表单验证
        this.$refs.userForm2.validate((valid) => {
            if (valid) {
            // 2 提交表单
                ajaxObj({url: "courses/update",method: "post",
                    data:this.form2
                })
                .then((response) => {
                    this.$message({ type: 'success', message: '修改成功' });
                    this.reload()                                               
                })
            } else {
                this.$message({ type: 'error', message: '修改失败' })
            }
        })
    },
    
    //  查看课程content  tips
    
    findList(id){
        ajaxObj({url: "tasks/level3",method: "get",params:{page:0,size:50,courseId:id}})
        .then(response => {
            console.log(response.data)
            this.lessonData = response.data.data
        });
    
    },
    editListenData(row){
        this.lessonvisible = true;
        this.lessonData2 = row;
    },
    lookListenData(row){
        this.lessonvisible2 = true;
        this.lessonData2 = row;        
    },
    //  修改课程content  tips
    editlookListenData(){
        this.$refs.lessonData2.validate((valid) => {
            console.log(valid)
            if (valid) {
                // 2 提交表单
                ajaxObj({url: "tasks/content",method: "post",
                    data:{'taskId':this.lessonData2.id,'content':this.lessonData2.content}
                })
                ajaxObj({url: "tasks/tips",method: "post",
                    data:{'taskId':this.lessonData2.id,'content':this.lessonData2.tips}
                })


                ajaxObj({url: "tasks/handling-instruction",method: "post",
                    data:{'taskId':this.lessonData2.id,'content':this.lessonData2.handlingInstruction}
                })

                .then((response) => {
                    this.$message({ type: 'success', message: '修改成功' });
                    this.lessonvisible = false;
                    //this.reload()                                               
                })
            } else {
                this.$message({ type: 'error', message: '修改失败' })
            }
        })
    },



    //  删除课程
     deleteHandler(row){
        if(row){
            ajaxObj({url: "courses/delete",method: "post", data:{"id":row.id}})
            .then(response => {
                this.$message({ type: 'success', message: '删除成功'});
                this.reload()
            });
        } else {
                this.$message({ type: 'error', message: '删除失败' })
        }
        
     },
    //  修改课程
     editHandler(row){
      this.form2 = row
      this.setTitle2('修改案例信息')
      this.showModal2()
     },
     
     // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange: function(size) {
    this.pagesize = size
    console.log(this.pagesize) // 每页下拉显示数据
    },
    handleCurrentChange: function(page) {
    this.query.currentPage = page;
    this.query.page = page-1;
    this.currentPage = page
    console.log(this.currentPage) // 点击第几页
        ajaxObj({url: "courses",method: "get",params:this.query})
        .then(response => {
            this.tableData = response.data.data;
            this.query.total = response.data.meta.total;
        })
    },

 },
 created(){
    this.findUserlist();    
   
 }
}
</script>

<style scoped>
.page {
    width: 100%;
    height: 100%;
}
.head {
    padding: 20px;
    font-size: 20px;
    border-bottom: 1px solid #ccc;
    box-sizing:border-box;

}
.bar {
    height: 100px;
    box-sizing:border-box;
    padding: 20px;
    font-size: 18px;
    padding-left: 60px;
    display:flex;
    align-items:center;
}
.bartip {
    margin: 0 8px 0 8px;
}
.table {
    width:98%;
    margin:0 auto;
}
.el-pagination {
    text-align: right;
    box-sizing: border-box;
    padding-right: 100px;
    padding-top: 20px;
}
.el-icon-circle-plus {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/system/lessonManagement.vue